import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PAYMENT_HANDSHAKE_SESSION_KEY_PREFIX } from 'paylink-constants';

@Injectable({ providedIn: 'root' })
export class PaymentHandshakeStoreService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly memory = new Map<string, string>();

  set(signupUuid: string, token: string): void {
    if (!signupUuid?.trim() || !token?.trim()) {
      return;
    }

    this.memory.set(signupUuid, token);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(this.storageKey(signupUuid), token);
    }
  }

  get(signupUuid: string): string | null {
    if (!signupUuid?.trim()) {
      return null;
    }

    const cached = this.memory.get(signupUuid);
    if (cached) {
      return cached;
    }

    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    return sessionStorage.getItem(this.storageKey(signupUuid));
  }

  clear(signupUuid: string): void {
    if (!signupUuid?.trim()) {
      return;
    }

    this.memory.delete(signupUuid);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem(this.storageKey(signupUuid));
    }
  }

  private storageKey(signupUuid: string): string {
    return `${PAYMENT_HANDSHAKE_SESSION_KEY_PREFIX}${signupUuid}`;
  }
}
